export default "__VITE_ASSET__52bda1ab__"